import { startPageUrl } from '../lib/sites';

// What a staff site shows while it has no sign-in (hooks/useStaffSession.js):
// a moment of "Signing you in…" while the browser goes to the start page and
// back, or why it stopped.
export default function StaffSignIn({ session, siteName }) {
  if (!session.problem) {
    return <div style={s.wrap}><p style={s.quiet}>Signing you in…</p></div>;
  }
  return (
    <div style={s.wrap}>
      <div style={s.box}>
        <img src="/logo.png" alt="Silver Service" style={s.logo} />
        <div style={s.site}>{siteName}</div>
        <p style={s.problem}>{session.problem}</p>
        <button type="button" style={s.primary} onClick={session.retry}>Try again</button>
        <a href={startPageUrl()} style={s.link}>All sites</a>
      </div>
    </div>
  );
}

const s = {
  wrap: { minHeight: '100vh', background: '#f5f5f5', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16, boxSizing: 'border-box', fontFamily: "'Inter', sans-serif" },
  quiet: { color: '#888', fontSize: '0.95rem', margin: 0 },
  box: { background: '#fff', borderRadius: 12, padding: '2rem', maxWidth: 380, width: '100%', boxShadow: '0 4px 24px rgba(0,0,0,0.06)', display: 'flex', flexDirection: 'column', gap: 14, textAlign: 'center' },
  logo: { height: 40, alignSelf: 'center' },
  site: { color: '#A50B18', fontWeight: 700, fontSize: '1.05rem' },
  problem: { color: '#444', fontSize: '0.92rem', margin: 0, lineHeight: 1.5 },
  primary: { background: '#A50B18', color: '#fff', border: 'none', borderRadius: 8, padding: '0.75rem 1rem', fontSize: '0.92rem', fontWeight: 600, cursor: 'pointer' },
  link: { color: '#888', fontSize: '0.85rem' },
};
